import { render, staticRenderFns } from "./Huaban.vue?vue&type=template&id=e82774c8&"
import script from "./Huaban.vue?vue&type=script&lang=js&"
export * from "./Huaban.vue?vue&type=script&lang=js&"
import style0 from "./Huaban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports